import { DismissibleAlert } from "@/components/base/dismissible-alert";
import { Link } from "@/components/base/link";

export function ParentLinkAlert() {
  return (
    <DismissibleAlert
      dismissKey="parent-link-alert"
      color="warning"
      collapsible
      title="Parents: Link Your Child's Profile"
      description={
        <>
          <p>
            No more managing multiple logins. Log in to your own account{" "}
            <Link to="/sign-up">(or create one)</Link>, then use "Link Existing
            Player" on your{" "}
            <Link to="/account" className="font-medium underline">
              account page
            </Link>{" "}
            to connect their profile.
          </p>
          <img
            className="mt-4 rounded-lg"
            src="/screen-shots/link-account.png"
            alt="click Add profile to see Link Existing Player option."
          />
        </>
      }
    />
  );
}
